import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { GettingStarted } from './pages/GettingStarted';
import { CommandCenter } from './pages/CommandCenter';
import { Contacts } from './pages/Contacts';
import { ContactDetail } from './pages/ContactDetail';
import { EmailOps } from './pages/EmailOps';
import { SupportOps } from './pages/SupportOps';
import { FinanceOps } from './pages/FinanceOps';
import { Partnerships } from './pages/Partnerships';
import { GrowthEngine } from './pages/GrowthEngine';
import { MessagingHub } from './pages/MessagingHub';
import { VoiceOps } from './pages/VoiceOps';
import { ContextExplorer } from './pages/ContextExplorer';
import { Settings } from './pages/Settings';
import { AuditLog } from './pages/AuditLog';
import { Today } from './pages/Today';
import { Inbox } from './pages/Inbox';
import { useAuthStore } from './stores/authStore';
import { ToastContainer } from './components/ui/Toast';
import { CommandPalette } from './components/ui/CommandPalette';
import { getToken } from './lib/api';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuthStore();
  // While checking auth, show nothing (prevents flash to login)
  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  const [ready, setReady] = useState(false);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    // On mount: if we have a stored token, try to restore the session
    if (getToken()) {
      checkAuth().finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ready) return null; // Loading auth state

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/getting-started"
          element={
            <ProtectedRoute>
              <GettingStarted />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<CommandCenter />} />
          <Route path="today" element={<Today />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/:id" element={<ContactDetail />} />
          <Route path="email" element={<EmailOps />} />
          <Route path="support" element={<SupportOps />} />
          <Route path="finance" element={<FinanceOps />} />
          <Route path="partnerships" element={<Partnerships />} />
          <Route path="growth" element={<GrowthEngine />} />
          <Route path="messaging" element={<MessagingHub />} />
          <Route path="voice" element={<VoiceOps />} />
          <Route path="context" element={<ContextExplorer />} />
          <Route path="settings" element={<Settings />} />
          <Route path="audit" element={<AuditLog />} />
        </Route>
      </Routes>
      <ToastContainer />
      <CommandPalette />
    </>
  );
}
